import { ExtendedCarItemType } from '@/interfaces/cars.interfaces';

import { CarStatusType } from '../types';

const getCarStatus = (extendedData: ExtendedCarItemType): CarStatusType | null => {
  const { logisticStatus } = extendedData.data;
  if (logisticStatus?.displayName) {
    return {
      label: logisticStatus.displayName,
      iconColor: logisticStatus?.color || undefined,
    };
  }
  return null;
};

export default getCarStatus;
